export enum FilterType {
    Author = 'author',
    Category = 'category',
    CourseType = 'course-type',
    Group = 'group',
    Skill = 'skill',
    Topic = 'topic',
}

export enum FilterMode {
    Inclusive = 'inclusive',
    Exclusive = 'exclusive',
}

export type Filters = Partial<Record<FilterType, { value: Array<number | string>; mode?: FilterMode }>>;

export type Option = {
    value: number | string;
    label: string;
};
